import { createRouter, createWebHistory } from "vue-router";
import authGuard from "@/router/guards/authGuard";
import mitt from "@/application/plugins/mitt";
import i18n from "@/application/plugins/i18n";

import { routes as membersRoutes } from "@/modules/members/routes";
import { routes as periodsRoutes } from "@/modules/periods/routes";
import { routes as categoriesRoutes } from "@/modules/categories/routes";
import { routes as tasksRoutes } from "@/modules/tasks/routes";
import { routes as settingsRoutes } from "@/modules/settings/routes";
import { routes as authRoutes } from "@/modules/auth/routes";
import { routes as errorRoutes } from "@/modules/shared/error/routes";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "",
      component: () => import("@/application/layouts/DefaultLayout.vue"),
      children: [
        ...membersRoutes,
        ...periodsRoutes,
        ...categoriesRoutes,
        ...tasksRoutes,
        ...settingsRoutes,
        {
          path: "",
          redirect: { name: "members.index" },
          meta: { requiresAuth: true },
        },
      ],
    },
    {
      path: "",
      component: () => import("@/application/layouts/AuthLayout.vue"),
      children: [...authRoutes],
    },
    ...errorRoutes,
  ],
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
});

router.beforeEach(authGuard);

router.onError((err) => {
  if (err?.message?.includes?.("Failed to fetch dynamically imported module")) {
    mitt.emit("snackbar", {
      text: i18n.global.t("errors.updateAvailable"),
      color: "error",
      location: "top center",
      persistent: true,
      actions: [
        {
          text: i18n.global.t("actions.refreshPage"),
          action: () => window.location.reload(),
          icon: "$sync",
        },
      ],
    });
  }
});

export default router;
